import React from "react";
import { cn } from "@shared/utils";

interface AuthorLogoProps {
  className?: string;
}

export const AuthorLogo: React.FC<AuthorLogoProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={cn("w-full h-full", className)}
    >
      <path
        fill="currentColor"
        d="M50 100l25-43 25 43V0H75L50 43 25 0H0v100l25-43z"
      />
    </svg>
  );
};
